import axios from '../axios';
// import router from '@/router/index';

export default {
  namespaced: true,
  state: () => ({
    document_types: [],
    staff_types: []
  }),
  actions: {
    async list(_, payload) {
      try {
        const response = await axios.get(`/documents/v2?term=${payload.term}&type=${payload.type}&page=${payload.page}`);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async get(_, id) {
      try {
        const { data } = await axios.get(`/documents/${id}`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async edit(_, id) {
      try {
        const { data } = await axios.get(`/documents/${id}/edit`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async get_types({ commit }) {
      try {
        const response = await axios.get(`/documents/documents_type`);
        commit('SET_NEWS_TYPES', response.data);
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async store(_, form_data) {
      try {
        const { data } = await axios.post(`/documents`, form_data);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async update(_, form_data) {
      try {
        const { data } = await axios.post(`/documents/${form_data.get('id')}`, form_data);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async delete(_, id) {
      try {
        const { data } = await axios.delete(`/documents/${id}`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async get_ref({ commit }) {
      try {
        const { data } = await axios.get(`/documents/reference?ref=all`);
        commit('SET_STAFF_TYPES', data.staff_types);
        commit('SET_DOCUMENT_TYPES', data.document_types);
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    }
  },
  mutations: {
    SET_STAFF_TYPES(state, data) { state.staff_types = data },
    SET_DOCUMENT_TYPES(state, data) { state.document_types = data },
  }
    
}